import {
  // LabelLang,
  LabelLangString,
} from "component/LabelLang/label-lang";
// import Linkable from "component/LinkableComponent/linkable-component";
import ContentLoading from "component/LoadingComponent/ContentLoading";
// import AutoCompleteComponent from "component/shared/AutoCompleteComponent";
import Dropdown from "component/shared/dropdown/Dropdown";
import { EXTERNAL_TRADE_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import { itemsReportDisplayType, reportType } from "constants/Defaults";
// import { TextSlicer } from "functions/textSlicer";
import { useEffect, useRef, useState } from "react";
// import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import ChevronIcon from "svg-icons/chevron-icon";
import useSWR from "swr";
// import ArrowDropDownIcon from "svg-icons/arrow-dropdown-icon";
import { Table } from "react-bootstrap";
import Paginator from "component/shared/Paginator/Paginator";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { MonthName } from "functions/monthName";
import { useReactToPrint } from "react-to-print";
import ReplayIcon from "@mui/icons-material/Replay";
import numberWithCommas from "functions/numericWithCommas";
import SnackbarModal from "component/shared/snackbar";
import ReactGA from "react-ga4";

const Items = ({ yearMonthDate }) => {
  const intl = useIntl();
  const dir = useSelector(({ theme }) => theme.direction);
  const pdfImage = process.env.PUBLIC_URL + "/image/pdf.png";
  const excelImage = process.env.PUBLIC_URL + "/image/Excel.svg";
  const pdfHeader = process.env.PUBLIC_URL + "/image/pdfHeader.png";
  const pdfFooter = process.env.PUBLIC_URL + "/image/pdfFooter.png";
  const maxDate = new Date().toJSON().slice(0, 10);
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const [searchTerm, setSearchTerm] = useState("");

                  
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/external-trade", title: "Country-Specific-Item External Trade Page" });
  }, []);


  const countriesData = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.COUNTRIES}`,
  });

  const itemsData = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.ITEMS}${
      searchTerm ? searchTerm : "default-dummy"
    }`,
  });
  const renderOptions = () => {
    const defaultOption = { id: 0, title: "", isAdvancedSearch: true };
    const emptyListOption = { id: 0, title: "", isListEmpty: true };
    if (!itemsData.data || itemsData.isLoading || itemsData.error) {
      return [defaultOption];
    }
    if (itemsData.data.data.length > 0) {
      return [...itemsData.data.data.slice(0, 20)];
    }
    return [emptyListOption, defaultOption];
  };
  const handleSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
  };
  // const defaultQueryState = {
  //     searchTerm: "",
  // };
  // const [queryFilters, setQueryFilters] = useState(defaultQueryState);
  // const callSearchApi = () => {
  //     if (queryFilters.searchTerm === "" || queryFilters.searchTerm === null) {
  //         return false;
  //     }
  //     return true;
  // };

  // const renderOptions = () => {
  //     const defaultOption = { id: 0, title: "", isAdvancedSearch: true };
  //     const emptyListOption = { id: 0, title: "", isListEmpty: true };
  //     if (
  //         !itemsData.data ||
  //         itemsData.isLoading ||
  //         itemsData.error
  //     ) {
  //         return [defaultOption];
  //     }
  //     if (itemsData.data.data.length > 0) {
  //         return [...itemsData.data.data.slice(0, 10), defaultOption];
  //     }
  //     return [emptyListOption, defaultOption];
  // };

  // const handleSearch = (searchTerm) => {
  //     setSearchTerm(searchTerm);
  //     setQueryFilters({ searchTerm: searchTerm });
  // };

  const defaultState = {
    ItemsDisplayType: null,
    itemId: null,
    ReportType: null,
    FromMonth: null,
    ToMonth: null,
    FromYear: null,
    ToYear: null,
    PageSize: 10,
    CurrentPage: 1,
  };

  const [filters, setFilters] = useState(defaultState);
  const [changeState, setChangeState] = useState(defaultState);
  const [changeCount, setChangeCount] = useState(defaultState);
  const [filterCount, setFilterCount] = useState(defaultState);
  const [itemId, setItemId] = useState(0);

  const handelFilterData = (e) => {
    let filterData = { ...changeState };
    if (e.target.name === "FromDate") {
      filterData["FromMonth"] = e.target.value.slice(5, 7);
      filterData["FromYear"] = e.target.value.slice(0, 4);
    } else if (e.target.name === "ToDate") {
      filterData["ToMonth"] = e.target.value.slice(5, 7);
      filterData["ToYear"] = e.target.value.slice(0, 4);
    } else {
      filterData[e.target.name] = e.target.value;
    }
    setChangeState(filterData);

    let count = { ...changeCount };
    if (e.target.name === "FromDate") {
      count["FromMonth"] = e.target.value.slice(5, 7);
      count["FromYear"] = e.target.value.slice(0, 4);
    } else if (e.target.name === "ToDate") {
      count["ToMonth"] = e.target.value.slice(5, 7);
      count["ToYear"] = e.target.value.slice(0, 4);
    } else {
      count[e.target.name] = e.target.value;
    }
    setChangeCount(count);
  };

  const onPageIndexChange = (e, value) => {
    setFilters((prevState) => ({
      ...prevState,
      CurrentPage: value,
    }));
  };

  const reportFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.ITEMS_REPORT}`,
    params: filters,
  });

  const countFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.ITEMS_REPORT}`,
    params: filterCount,
  });

  const [reportTypeInfo, setReportTypeInfo] = useState();
  const handelChangeReportType = (e) => {
    setReportTypeInfo(
      reportType.find((el) => +el.id === +changeState.ReportType)
    );
  };

  const [displatTypeInfo, setDisplatTypeInfo] = useState();
  const handelChangeDisplatType = (e) => {
    setDisplatTypeInfo(
      itemsReportDisplayType.find(
        (el) => +el.id === +changeState.ItemsDisplayType
      )
    );
  };

  const [itemInfo, setItemInfo] = useState();
  const handelChangeItemId = (e) => {
    setItemInfo(
      itemsData?.data?.data &&
        itemsData?.data?.data.find((el) => +el.id === itemId)
    );
  };

  const [hiddinLabel, setHiddinLabel] = useState(false);
  const resetForm = () => {
    setHiddinLabel(true);
    setFilters(defaultState);
    setFilterCount(defaultState);
    document.querySelectorAll("input").value = "";
    document.querySelectorAll("select").value = 0;
    document.getElementById("combo-box-demo").style.opacity = "0";
  };

  const elementPdf = useRef(null);
  const generateToPDF = useReactToPrint({
    documentTitle: `${
      dir === "rtl" ? "طبقـا للصنـف" : "By item"
    } - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: reportTypeInfo?.name,
      translations: reportTypeInfo?.translations,
    })} - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: displatTypeInfo?.name,
      translations: displatTypeInfo?.translations,
    })} - ( ${filterCount?.FromMonth}/${filterCount?.FromYear} - ${
      filterCount?.ToMonth
    }/${filterCount?.ToYear} ) / ${itemInfo?.hsn ?? itemInfo?.id}`,
    content: () => elementPdf.current,
    bodyClass: `${dir === 'rtl' ? 'exportBody-rtl' : 'exportBody-ltr'}`
  });

  // error
  const [openError, setOpenError] = useState(false);
  const handleOpenError = () => {
      setOpenError(true);
  };
  const handleCloseError = () => {
      setOpenError(false);
  };

  const [alertEmptyData, setAlertEmptyData] = useState(false);
  const handleOpenAlert = () => {
      setAlertEmptyData(true);
  };
  const handleCloseAlert = () => {
      setAlertEmptyData(false);
  };

  return (
    <ContentLoading isLoading={countriesData.isLoading}>
      <div className="active-item-news-tabs">
        <div className="browsetopic-box alls mb-0 py-3">
          <div className="container">
            <form
              className="row gy-3 align-items-center"
              onSubmit={(e) => {
                e.preventDefault();
                if(changeState.ItemsDisplayType && itemId && changeState.ReportType && changeState.FromMonth && changeState.FromYear && changeState.ToMonth && changeState.ToYear) {
                  handleCloseAlert();
                  if (new Date(`${+changeState.ToYear}-${+changeState.ToMonth}`) >= new Date(`${+changeState.FromYear}-${+changeState.FromMonth}`)) {
                    handelChangeItemId();
                    handelChangeReportType();
                    handelChangeDisplatType();
                    setFilters({ ...changeState, itemId: itemId });
                    setFilterCount({
                      ...changeCount,
                      itemId: itemId,
                      PageSize: null,
                      CurrentPage: null,
                    });
                  } else {
                    handleOpenError()
                  }
                }
                else {
                  handleOpenAlert();
                }
              }}
            >
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="ReportType">
                    <FormattedMessage id="statement-type" />
                  </label>
                </div>
                <Dropdown
                  item={reportType}
                  name={"ReportType"}
                  placeholder={intl.formatMessage({
                    id: "choose-statement-type",
                  })}
                  change={handelFilterData}
                  required={true}
                />
              </div>
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="ItemsDisplayType">
                    <FormattedMessage id="display-type" />
                  </label>
                </div>
                <Dropdown
                  item={itemsReportDisplayType}
                  name={"ItemsDisplayType"}
                  placeholder={intl.formatMessage({
                    id: "choose-display-type",
                  })}
                  change={handelFilterData}
                  required={true}
                />
              </div>
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="FromDate">
                    <FormattedMessage id="fromDate" />
                  </label>
                  <input
                    name="FromDate"
                    id="FromDate"
                    onChange={handelFilterData}
                    type="month"
                    style={{ textAlign: dir === "rtl" ? "end" : "start" }}
                    min={
                      +changeState.ReportType === 1 ||
                      +changeState.ReportType === 0
                        ? `${+yearMonthDate?.importMinYear}-${
                            +yearMonthDate?.importMinMonth < 10
                              ? `0${+yearMonthDate?.importMinMonth}`
                              : +yearMonthDate?.importMinMonth
                          }`
                        : `${+yearMonthDate?.exportMinYear}-${
                            +yearMonthDate?.exportMinMonth < 10
                              ? `0${+yearMonthDate?.exportMinMonth}`
                              : +yearMonthDate?.exportMinMonth
                          }`
                    }
                    max={
                      +changeState.ReportType === 1 ||
                      +changeState.ReportType === 0
                        ? `${+yearMonthDate?.importMaxYear}-${
                            +yearMonthDate?.importMaxMonth < 10
                              ? `0${+yearMonthDate?.importMaxMonth}`
                              : +yearMonthDate?.importMaxMonth
                          }`
                        : `${+yearMonthDate?.exportMaxYear}-${
                            +yearMonthDate?.exportMaxMonth < 10
                              ? `0${+yearMonthDate?.exportMaxMonth}`
                              : +yearMonthDate?.exportMaxMonth
                          }`
                    }
                    className="form-control position-relative"
                    // required
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="ToDate">
                    <FormattedMessage id="toDate" />
                  </label>
                  <input
                    name="ToDate"
                    id="ToDate"
                    onChange={handelFilterData}
                    type="month"
                    style={{ textAlign: dir === "rtl" ? "end" : "start" }}
                    min={
                      +changeState.ReportType === 1 ||
                      +changeState.ReportType === 0
                        ? `${+yearMonthDate?.importMinYear}-${
                            +yearMonthDate?.importMinMonth < 10
                              ? `0${+yearMonthDate?.importMinMonth}`
                              : +yearMonthDate?.importMinMonth
                          }`
                        : `${+yearMonthDate?.exportMinYear}-${
                            +yearMonthDate?.exportMinMonth < 10
                              ? `0${+yearMonthDate?.exportMinMonth}`
                              : +yearMonthDate?.exportMinMonth
                          }`
                    }
                    max={
                      +changeState.ReportType === 1 ||
                      +changeState.ReportType === 0
                        ? `${+yearMonthDate?.importMaxYear}-${
                            +yearMonthDate?.importMaxMonth < 10
                              ? `0${+yearMonthDate?.importMaxMonth}`
                              : +yearMonthDate?.importMaxMonth
                          }`
                        : `${+yearMonthDate?.exportMaxYear}-${
                            +yearMonthDate?.exportMaxMonth < 10
                              ? `0${+yearMonthDate?.exportMaxMonth}`
                              : +yearMonthDate?.exportMaxMonth
                          }`
                    }
                    className="form-control position-relative"
                    // required
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="item-form coll">
                  <label htmlFor="itemId">
                    <FormattedMessage id="item" />
                  </label>
                </div>
                <AsyncTypeahead
                  isLoading={false}
                  id="basic-typeahead-single"
                  labelKey={(option) => {
                    setItemId(option.id);
                    return hiddinLabel
                      ? ""
                      : option.hsn +
                          " - " +
                          `${
                            dir === "rtl"
                              ? option.name
                              : option.translations?.length > 0
                              ? option.translations[0]?.name
                              : option.name
                          }`;
                  }}
                  filterBy={(option) => {
                    return option.id.toString();
                  }}
                  options={renderOptions()}
                  onSearch={handleSearch}
                  onChange={() => setHiddinLabel(false)}
                  placeholder={intl.formatMessage({ id: "search" })}
                  emptyLabel={intl.formatMessage({ id: "data-not-found" })}
                  renderMenuItemChildren={(option) => {
                    if (option.isListEmpty) {
                      return (
                        <div className="data-not-found-item">
                          <FormattedMessage id="data-not-found" />
                        </div>
                      );
                    }
                    return dir == "rtl" ? (
                      <div style={{ textAlign: "right" }}>
                        <label title={option.name}>
                          {option.hsn}
                          {option.hsn && " - "}
                          {option.name}
                          {/* {option.name?.slice(0, 92)} */}
                          {/* {option.name?.length > 92 ? "... " : ""} */}
                        </label>
                      </div>
                    ) : (
                      <label
                        title={
                          option.translations?.length > 0
                            ? option.translations[0]?.name
                            : option.name
                        }
                      >
                        {
                          option.hsn && option.translations?.length > 0
                            ? option.hsn + " - " + option.translations[0].name
                            : // option.translations[0].name.slice(0, 92) +
                              // (option.name?.length > 92 ? "... " : "")
                              option.hsn + " - " + option.name
                          // option.name?.slice(0, 92) +
                          // (option.name?.length > 92 ? "... " : "")
                        }
                        {/* {option.name?.length > 92 ? "... " : ""} */}
                      </label>
                    );
                  }}
                />
              </div>
              <div className="col-12 col-xl-3">
                <div className="text-white fw-bold mt-3">
                  <span>
                    <FormattedMessage id="allow-data" />
                  </span>
                  <span
                    className={`content h5 mb-0 fw-bold ${
                      dir === "rtl" ? "me-2" : "ms-2"
                    }`}
                    style={{ color: "var(--second-color)" }}
                  >
                    {+changeState.ReportType === 1 ||
                    +changeState.ReportType === 0
                      ? `${+yearMonthDate?.importMaxYear}-${
                          +yearMonthDate?.importMaxMonth < 10
                            ? `0${+yearMonthDate?.importMaxMonth}`
                            : +yearMonthDate?.importMaxMonth
                        }`
                      : `${+yearMonthDate?.exportMaxYear}-${
                          +yearMonthDate?.exportMaxMonth < 10
                            ? `0${+yearMonthDate?.exportMaxMonth}`
                            : +yearMonthDate?.exportMaxMonth
                        }`}
                  </span>
                </div>
              </div>
              <div className="col-12 col-xl-9 ">
                <div className="row align-items-center justify-content-end mt-3">
                  {countFetching?.data?.data?.items &&
                    Object.keys(countFetching?.data?.data?.items).length >
                      0 && (
                      <div className="col-lg-5 col-md-6 col-12">
                        <div className="text-white fw-bold">
                          <span>
                            <FormattedMessage id="download-data" />
                          </span>
                          <span
                            className={`content ${
                              dir === "rtl" ? "me-3" : "ms-3"
                            }`}
                          >
                            <span
                              className={`sp-icon ${
                                dir === "rtl" ? "ms-3" : "me-3"
                              }`}
                              onClick={() => {
                                generateToPDF();
                              }}
                            >
                              <img
                                src={pdfImage}
                                style={{
                                  width: "40px",
                                  cursor: "pointer",
                                  borderRadius: "6px",
                                }}
                                alt="pdf-image"
                              />
                            </span>
                            <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className={`border-0 bg-transparent`}
                              table={`table-to-xls-items-report`}
                              filename={`${
                                dir === "rtl" ? "طبقـا للصنـف" : "By item"
                              } - ${LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: reportTypeInfo?.name,
                                translations: reportTypeInfo?.translations,
                              })} - ${LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: displatTypeInfo?.name,
                                translations: displatTypeInfo?.translations,
                              })} - ( ${filterCount.FromMonth}/${
                                filterCount.FromYear
                              } - ${filterCount.ToMonth}/${
                                filterCount.ToYear
                              } ) / ${itemInfo?.hsn ?? itemInfo?.id}`}
                              sheet="tablexls"
                              buttonText={
                                <span className="sp-icon">
                                  <img
                                    src={excelImage}
                                    style={{
                                      width: "40px",
                                      cursor: "pointer",
                                      borderRadius: "6px",
                                    }}
                                    alt="excel-image"
                                  />
                                </span>
                              }
                            />
                          </span>
                        </div>
                      </div>
                    )}
                  <div className="col-lg-7 col-md-6 col-12">
                    <div className="d-flex gap-2 mt-3 mt-md-0">
                      <button type="submit" className="main-btn">
                        <span>
                          <FormattedMessage id="view-data" />
                        </span>
                        <ChevronIcon width={12} height={12} />
                      </button>
                      <button
                        type="reset"
                        className="second-btn"
                        onClick={() => {
                          resetForm();
                        }}
                      >
                        <span>
                          <FormattedMessage id="reset" />
                        </span>
                        <ReplayIcon style={{ fontSize: 20 }} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* error */}
        <SnackbarModal open={openError} onClose={handleCloseError} severity="error" message={intl.formatMessage({
          id: "fromDate_ToDate_Role",
        })} />

        <SnackbarModal open={alertEmptyData} onClose={handleCloseAlert} severity="error" message={intl.formatMessage({
          id: "must_fill_all_fields",
        })} />

        <div className="body-news pt-4">
          {reportFetching?.isLoading ? (
            <h5 className="text-center" dir="ltr">
              <FormattedMessage id="loading..." />
            </h5>
          ) : reportFetching?.data?.data?.items && filters.itemId ? (
            Object.keys(reportFetching?.data?.data?.items).length > 0 ? (
              <>
                <Table
                  responsive
                  striped
                  bordered
                  hover
                  className="text-center"
                >
                  <thead
                    className="text-white main-bg"
                    
                  >
                    <tr>
                      <th
                        colSpan={6}
                      >
                        {LabelLangString({
                          id: "name",
                          currentLocale: currentLocale,
                          defaultValue: reportTypeInfo?.name,
                          translations: reportTypeInfo?.translations,
                        })}{" "}
                        -{" "}
                        {LabelLangString({
                          id: "name",
                          currentLocale: currentLocale,
                          defaultValue: displatTypeInfo?.name,
                          translations: displatTypeInfo?.translations,
                        })}{" "}
                        - {dir === "rtl" ? "طبقـا للصنـف" : "By item"}{" "}
                        -- ( <FormattedMessage id="period-from" />{" "}
                        {`${filters.FromMonth}/${filters.FromYear}`} -{" "}
                        <FormattedMessage id="to" />{" "}
                        {`${filters.ToMonth}/${filters.ToYear}`} )
                      </th>
                    </tr>
                    <tr>
                      <th
                        colSpan={6}
                      >
                        {itemInfo?.hsn ?? itemInfo?.id} -{" "}
                        {LabelLangString({
                          id: "name",
                          currentLocale: currentLocale,
                          defaultValue: itemInfo?.name,
                          translations: itemInfo?.translations,
                        })}
                      </th>
                    </tr>
                    <tr>
                      <th
                        colSpan={6}
                      >
                        {intl.formatMessage({
                          id: "quantity-data-under-constraction",
                        })}
                      </th>
                    </tr>
                    <tr>
                      <th style={{ width: "30%" }}>
                        {intl.formatMessage({
                          id: `${
                            reportFetching?.data?.data?.items[0]?.country
                              ? "country"
                              : reportFetching?.data?.data?.items[0]?.port
                              ? "port"
                              : reportFetching?.data?.data?.items[0]?.month
                              ? "the-month"
                              : reportFetching?.data?.data?.items[0]?.year
                              ? "year"
                              : "country"
                          }`,
                        })}
                      </th>
                      <th>{intl.formatMessage({ id: "pound-value" })}</th>
                      <th>{intl.formatMessage({ id: "dollar-value" })}</th>
                      <th>{intl.formatMessage({ id: "unit" })}</th>
                      <th>{intl.formatMessage({ id: "quantity" })}</th>
                      <th>{intl.formatMessage({ id: "quantity-number" })}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {+countFetching?.data?.data?.totals?.egTotals > 0 &&
                      +countFetching?.data?.data?.totals?.usdTotals > 0 && (
                        <tr>
                          <td>{intl.formatMessage({ id: "totaly" })}</td>
                          <td>
                            {numberWithCommas(
                              countFetching?.data?.data?.totals?.egTotals?.toFixed(2)
                            )}
                          </td>
                          <td>
                            {numberWithCommas(
                              countFetching?.data?.data?.totals?.usdTotals?.toFixed(2)
                            )}
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    <Paginator
                      size={filters.PageSize}
                      table={true}
                      colspan={6}
                      change={onPageIndexChange}
                      page={filters.CurrentPage}
                      totalCount={reportFetching?.data?.data?.pager?.totalCount}
                    >
                      {reportFetching?.data?.data?.items.map(
                        (
                          {
                            country,
                            port,
                            year,
                            month,
                            measure_Units,
                            measureUnit,
                            quantity,
                            quantityInNumber,
                            valueEGP,
                            valueUSD,
                          },
                          i
                        ) => (
                          <tr key={i}>
                            <td>
                              {month && year ? (
                                // <MonthName month={month} year={year} />
                                `${month}/${year}`
                              ) : year ? (
                                year
                              ) : month ? (
                                <MonthName month={month} />
                              ) : (
                                LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: country
                                    ? country?.name
                                    : port
                                    ? port?.name
                                    : "",
                                  translations: country
                                    ? country?.translations
                                    : port
                                    ? port?.translations
                                    : [],
                                })
                              )}
                            </td>
                            <td>{numberWithCommas(valueEGP?.toFixed(2))}</td>
                            <td>{numberWithCommas(valueUSD?.toFixed(2))}</td>
                            <td>
                              {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: measure_Units
                                  ? measure_Units?.name
                                  : measureUnit
                                  ? measureUnit?.name
                                  : "N/A",
                                translations: measure_Units
                                  ? measure_Units?.translations
                                  : measureUnit
                                  ? measureUnit?.translations
                                  : [],
                              })}
                            </td>
                            <td>{numberWithCommas(quantity?.toFixed(2))}</td>
                            <td>{numberWithCommas(quantityInNumber?.toFixed(2))}</td>
                          </tr>
                        )
                      )}
                    </Paginator>
                  </tbody>
                </Table>

                <div className="d-none">
                  <div ref={elementPdf}>
                    <img
                      src={pdfHeader}
                      alt="pdf-header"
                      className="w-100"
                      style={{
                        // position: "fixed",
                        top: "5px",
                        left: 1,
                        zIndex: 100000,
                      }}
                    />
                    <Table
                      responsive
                      striped
                      bordered
                      hover
                      className="text-center"
                      id={`table-to-xls-items-report`}
                    >
                      <thead
                        className="text-white main-bg"
                        
                      >
                        <tr>
                          <th
                            colSpan={6}
                          >
                            {maxDate}
                          </th>
                        </tr>
                        <tr>
                          <th
                            colSpan={6}
                          >
                            {LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: reportTypeInfo?.name,
                              translations: reportTypeInfo?.translations,
                            })}{" "}
                            -{" "}
                            {LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: displatTypeInfo?.name,
                              translations: displatTypeInfo?.translations,
                            })}{" "}
                            - {dir === "rtl" ? "طبقـا للصنـف" : "By item"}{" "}
                            - ( <FormattedMessage id="period-from" />{" "}
                            {`${filterCount.FromMonth}/${filterCount.FromYear}`} -{" "}
                            <FormattedMessage id="to" />{" "}
                            {`${filterCount.ToMonth}/${filterCount.ToYear}`} )
                          </th>
                        </tr>
                        <tr>
                          <th
                            colSpan={6}
                          >
                            {itemInfo?.hsn ?? itemInfo?.id} -{" "}
                            {LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: itemInfo?.name,
                              translations: itemInfo?.translations,
                            })}
                          </th>
                        </tr>
                        <tr>
                          <th
                            colSpan={6}
                          >
                            {intl.formatMessage({
                              id: "quantity-data-under-constraction",
                            })}
                          </th>
                        </tr>
                        <tr>
                          <th style={{ width: "30%" }}>
                            {intl.formatMessage({
                              id: `${
                                countFetching?.data?.data?.items[0]?.country
                                  ? "country"
                                  : countFetching?.data?.data?.items[0]?.port
                                  ? "port"
                                  : countFetching?.data?.data?.items[0]?.month
                                  ? "the-month"
                                  : countFetching?.data?.data?.items[0]?.year
                                  ? "year"
                                  : "country"
                              }`,
                            })}
                          </th>
                          <th>{intl.formatMessage({ id: "pound-value" })}</th>
                          <th>{intl.formatMessage({ id: "dollar-value" })}</th>
                          <th>{intl.formatMessage({ id: "unit" })}</th>
                          <th>{intl.formatMessage({ id: "quantity" })}</th>
                          <th>{intl.formatMessage({ id: "quantity-number" })}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {+countFetching?.data?.data?.totals?.egTotals > 0 &&
                          +countFetching?.data?.data?.totals?.usdTotals > 0 && (
                            <tr>
                              <td>{intl.formatMessage({ id: "totaly" })}</td>
                              <td>
                                {numberWithCommas(
                                  countFetching?.data?.data?.totals?.egTotals?.toFixed(2)
                                )}
                              </td>
                              <td>
                                {numberWithCommas(
                                  countFetching?.data?.data?.totals?.usdTotals?.toFixed(2)
                                )}
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        {countFetching?.data?.data?.items.map(
                          (
                            {
                              country,
                              port,
                              year,
                              month,
                              measure_Units,
                              measureUnit,
                              quantity,
                              quantityInNumber,
                              valueEGP,
                              valueUSD,
                            },
                            i
                          ) => (
                            <tr key={i}>
                              <td>
                                {month && year ? (
                                  // <MonthName month={month} year={year} />
                                  `${month}/${year}`
                                ) : year ? (
                                  year
                                ) : month ? (
                                  <MonthName month={month} />
                                ) : (
                                  LabelLangString({
                                    id: "name",
                                    currentLocale: currentLocale,
                                    defaultValue: country
                                      ? country?.name
                                      : port
                                      ? port?.name
                                      : "",
                                    translations: country
                                      ? country?.translations
                                      : port
                                      ? port?.translations
                                      : [],
                                  })
                                )}
                              </td>
                              <td>{numberWithCommas(valueEGP?.toFixed(2))}</td>
                              <td>{numberWithCommas(valueUSD?.toFixed(2))}</td>
                              <td>{LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: measure_Units
                                  ? measure_Units?.name
                                  : measureUnit
                                  ? measureUnit?.name
                                  : "N/A",
                                  translations: measure_Units
                                  ? measure_Units?.translations
                                  : measureUnit
                                  ? measureUnit?.translations
                                  : [],
                              })}</td>
                              <td>{numberWithCommas(quantity?.toFixed(2))}</td>
                              <td>{numberWithCommas(quantityInNumber?.toFixed(2))}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                    <img
                      src={pdfFooter}
                      alt="pdf-footer"
                      className="w-100"
                      style={{
                        // position: "fixed",
                        bottom: "10px",
                        left: 1,
                        zIndex: 100000,
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <h4 className="text-center">
                <FormattedMessage id="data-not-found" />
              </h4>
            )
          ) : (
            ""
          )}
        </div>
      </div>
    </ContentLoading>
  );
};

export default Items;
